import type { TripView } from "../../src/web/types.ts";

// Bringing the others in (features/getting-started.md): when the trip offers it, and what Invite says;
// and what Share says with a place's link (features/map.md).

// The day a moment falls on where the person is ("2026-10-15").
export function localDay(at: Date, timeZone?: string): string {
  return new Intl.DateTimeFormat("en-CA", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    ...(timeZone ? { timeZone } : {}),
  }).format(at);
}

// The server says whether the trip may offer it at all (its owner, alone in it, enough planned, not put
// away for good). The rest is the person's own clock: they came back on a later day than they made the
// trip, in their own time zone, and it isn't within the week they closed it for.
export function inviteDue(invite: TripView["invite"] | undefined, now: Date, timeZone?: string): boolean {
  if (!invite) return false;
  if (localDay(now, timeZone) <= localDay(new Date(invite.created_at), timeZone)) return false;
  return invite.snoozed_until === null || now >= new Date(invite.snoozed_until);
}

// The trip as the words around a link name it: "Japan trip", "Mei's birthday trip" (not "trip trip").
function ourTrip(title: string): string {
  const trip = /\btrip$/i.test(title.trim()) ? title.trim() : `${title.trim()} trip`;
  return `our ${trip}`;
}

// What the share sheet says with the link: "Join our Japan trip on Tripmo" (not "Japan trip trip").
export function inviteText(title: string): string {
  return `Join ${ourTrip(title)} on Tripmo`;
}

// What it says with a place's link, sent to the others to ask (features/map.md, Share): "teamLab Planets,
// on our Japan & Korea trip: interested?"
export function shareText(item: string, trip: string): string {
  return `${item.trim()}, on ${ourTrip(trip)}: interested?`;
}
